import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  Home,
  Products,
  Packages,
  PrivacyPolicy,
  ContactUs,
  test,
} from "../pages";
import ProductDetails from "../pages/Products/ProducDetails";
import ComprasionPackage from "../pages/ComprasionProduct/ComprasionPackage";
import ComprasionProduct from "../pages/ComprasionProduct/ComprasionProduct";
import { Layout } from "../components";

class AppRouter extends React.Component {
  render() {
    const hist = createBrowserHistory();
    return (
      <Router history={hist}>
        <Layout>
          <Switch>
            <Route exact path="/" component={Home} />

            <Route exact path="/products/:type?" component={Products} />
            <Route exact path="/packages" component={Packages} />
            <Route exact path="/privacyPolicy" component={PrivacyPolicy} />
            <Route exact path="/productDetails" component={ProductDetails} />
            <Route exact path="/contactUs" component={ContactUs} />
            <Route
              exact
              path="/compareProducts"
              component={ComprasionProduct}
            />
            <Route
              exact
              path="/comparePackages"
              component={ComprasionPackage}
            />
            <Route exact path="/test" component={test} />
          </Switch>
        </Layout>
      </Router>
    );
  }
}

export default AppRouter;
